import { ICampanhaDesconto } from "../../types/CupomDesconto/ICampanhaDesconto"
import { BaseApi } from "./BaseApi"
import qs from 'qs';

export class CupomDescontoApi extends BaseApi {
    async BuscarTodasCampanhasDescontosValidas(oidCliente: number, filialVenda: string, cpfCnpjCliente: string, clienteMais: boolean): Promise<ICampanhaDesconto[]> {
        const resposta = await this.api.post(`/CupomDesconto/BuscarTodasCampanhasDescontosValidas`, {
            oidCliente: oidCliente,
            filialVenda: filialVenda,
            cpfCnpjCliente:cpfCnpjCliente,
            clienteMais: clienteMais
        })

        return resposta?.data.Resultado
    }

    async BuscarCampanhaPorId(idCampanha: number): Promise<ICampanhaDesconto> {
        const resposta = await this.api.post(`/CupomDesconto/BuscarCampanhaPorId`, {
            idCampanha: idCampanha
        })
        if (!resposta?.data?.Resultado) {
            throw new Error("Ocorreu erro ao obter a campanha de desconto")
        }

        return resposta?.data.Resultado
    }

    async AdicionarCuponsOrcamento(identificadorOrcamento: string, idsCupons: number[], codigosProdutos: string[]): Promise<boolean> {
        const resposta = await this.api.post(`/CupomDesconto/AdicionarCuponsOrcamento`, {
            IdentificadorOrcamento: identificadorOrcamento,
            IdsCupons: idsCupons,
            CodigosProdutosOrcamento: codigosProdutos
        })
        
        return resposta?.data.Resultado
    }

    async ObterCuponsUtilizadosOrcamento(identificadorOrcamento: string): Promise<ICampanhaDesconto[]> {
        
        const resposta = await this.api.get(`/CupomDesconto/ObterCuponsUtilizadosOrcamento`, { params: { IdentificadorOrcamento: identificadorOrcamento } })

        return resposta?.data.Resultado
    }

    async VerificaProdutosFazemParteCampanhasDesconto(idsCupons: number[], codigosProdutos: string[]): Promise<string[]> {
        const resposta = await this.api.post(`/CupomDesconto/VerificaProdutosFazemParteCampanhasDesconto`, {
            IdsCupons: idsCupons,
            CodigosProdutosOrcamento: codigosProdutos
        })

        return resposta?.data.Resultado
    }
}